import React from 'react';
import {
    List,
    TextField,
    DatagridConfigurable,
    FunctionField,
    useGetList,
    Filter,
    DateInput,
    ArrayField,
    WithListContext,
    SelectInput, AutocompleteInput, useListContext, ReferenceInput, ReferenceField,
} from 'react-admin';
import moment from "moment";
import Chip from "@mui/material/Chip";
const AppointmentFilter = (props) => {
    const { filterValues } = useListContext();
    const {data: allTypes, isLoading: isLoadingTypes} =
        useGetList('admin/medical/appointment-types');
    const {data: allProviders, isLoading: isProvidersLoading} =
        useGetList('admin/providers');
    const {data: allTablespaces, isLoading} =
        useGetList('admin/medical/tablespaces');
    const selectedTablespace = (filterValues.tablespace_id && allTablespaces) ? allTablespaces.find(ts => ts.id === filterValues.tablespace_id) : null;
    const relevantTypeMap = selectedTablespace ? selectedTablespace.appointment_type_map: null
    const relevantTypes = relevantTypeMap && allTypes ? allTypes.filter(type => Object.keys(relevantTypeMap).includes(`${type.id}`)) : null
    return <Filter {...props}>

        <SelectInput
            alwaysOn
            source="tablespace_id"
            choices={allTablespaces}
            isLoading={isLoading}
            label="Tablespace"
            sx={{minWidth: 239}}
        />
        <DateInput source="appointment_date_after" name="appointment_date_after" label="Appointments After" alwaysOn />
        <DateInput source="appointment_date_before" name="appointment_date_before" label="Appointments Before" alwaysOn />
        <AutocompleteInput
            label="Appointment type"
            name="appointment_type_id"
            source="appointmentType"
            choices={relevantTypes}
            optionText={type => `${type.category} ${type.name}`}
            isLoading={isLoadingTypes || isLoading}
            sx={{minWidth: 300}}
        />
        <AutocompleteInput
            label="Provider"
            name="provider_id"
            source="providers"
            choices={allProviders}
            optionText={provider => `${provider.user?.first_name} ${provider.user?.last_name}`}
            isLoading={isProvidersLoading}
            sx={{minWidth: 300}}
        />
        <ReferenceInput reference="admin/user" source="user_id" label="User" name="user_id" sx={{minWidth: 300}}/>
    </Filter>
}

const AthenaNotesField = (note) => {
    let appointmentIDs;
    try {
        appointmentIDs = JSON.parse(note.text)
    }catch (_e) {return null}
    if (typeof appointmentIDs === 'object') {
        return <li key={note.id}>
            {Object.entries(appointmentIDs).map(([key, value]) => {
                switch (key) {
                    case 'acuityAppointmentId':
                        return <Chip key={key} label={`Acuity: ${value}`} />
                    case 'gennevAppointmentId':
                        return <Chip key={key} label={`Gennev: ${value}`} />
                }
            })}
        </li>
    } else return null;
}
const AppointmentStatus = (status) => {
    switch (status) {
        case 'f': return <Chip label='Booked' color="primary" variant="outlined" />
        case 'x': return <Chip label='Cancelled' color="error" />
        case 'o': return <Chip label='Open' color="secondary" />
        case '2': return <Chip label='Checked-in' color="success" variant="outlined" />
        case '4': return <Chip label='Paid' color="success" />
    }
    return null;
}



export const AthenaAppointmentList = () => {
    const today = moment().format('YYYY-MM-DD')
    return (
        <List title="Athena Appointments" filters={<AppointmentFilter />} filterDefaultValues={{tablespace_id: 1, appointment_date_after: today}}>
            <DatagridConfigurable rowClick={false}>
                <TextField source="appointmentid" />
                <FunctionField label="Provider" render={app => app.provider ? <ReferenceField reference="admin/providers" source="provider.id" /> : app.providerid} />
                <FunctionField label="Patient" render={app => app.user ? <ReferenceField  reference="admin/user" source="user.id" /> : app.patientid} />
                <FunctionField label="Date/Time" render={app => `${app.date} ${app.starttime}`} />
                <FunctionField label="Type" render={app => {
                    return <span>{app.appointmenttypeid}: {app.appointmenttype}{' '} -{' '}
                        {app.appointmentType && <ReferenceField record={app.appointmenttype} reference="admin/medical/appointment-types" source="appointmentType.id"/>}
                            </span>
                }} />

                <FunctionField label="Scheduled" render={app => `By ${app.scheduledby} on ${app.scheduleddatetime}`} />
                <FunctionField label="Modified" render={app => `By ${app.lastmodifiedby} on ${app.lastmodified}`} />
                <FunctionField label="Status" render={app => AppointmentStatus(app.appointmentstatus)} />
                <ArrayField source="appointmentnotes">
                    <WithListContext render={({ data }) => (
                        <ul>
                            {data?.map(note => AthenaNotesField(note))}
                        </ul>
                    )} />
                </ArrayField>
            </DatagridConfigurable>
        </List>
    );
};

